module.exports = __webpack_public_path__ + "media/images/buttercms/blog-2b1c03cd9f38e617859b52bce5b0e557.svg";